import React, { useEffect } from "react";
import "./login.css";
import useStore from "../../../useStore";
import { useForm } from "../../../Hooks/useForm";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import { FORM_LOGIN } from "../../../Constants/Login";
import { FormLoginScheme } from "../../../Models/Schemas/form-login";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import Input from "../../Elements/Input/Input";
import Button from "../../Elements/Button/Button";
import Loader from "../../Elements/Loader/Loader";

const Login = () => {
  const { fetchDataLogin, loading, error, success, resetError, resetSuccess } = useStore();
  const { showToast } = useToast();

  const { values, errors, touched, isValid, handleChange, handleBlur, handleSubmit } = useForm(
    FORM_LOGIN,
    FormLoginScheme(),
    (formValues) => fetchDataLogin(formValues)
  );

  useEffect(() => {
    if (error) {
      showToast("error", error);
      resetError();
    }
  }, [error, showToast, resetError]);

  useEffect(() => {
    if (success) {
      showToast("success", success);
      resetSuccess();
    }
  }, [success, showToast, resetSuccess]);

  return (
    <div className="login-page">
      {loading && <Loader message="Iniciando sesión..." />}
      <form className="login-card" onSubmit={handleSubmit}>
        <img
          className="login-logo"
          src="/assets/CASVI_Brand_Kit/PNG/CASVI_logo_transparent_2400px.png"
          alt="Casvi Software"
        />
        <h1>Iniciar sesión</h1>
        <Input
          label="Correo electrónico"
          name="email"
          type="email"
          placeholder="tu@correo.com"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={setErrorFormSimpleUtil(errors, touched, "email")}
        />
        <Input
          label="Contraseña"
          name="password"
          variant="Password"
          placeholder="••••••••"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          error={setErrorFormSimpleUtil(errors, touched, "password")}
        />
        <a className="login-link" href="/forgot-password">¿Olvidaste tu contraseña?</a>
        <Button text="Entrar" type="submit" disabled={!isValid || loading} classNames="login-submit" />
        <p className="login-footer">
          ¿No tienes cuenta? <a className="login-link" href="/register">Regístrate</a>
        </p>
      </form>
    </div>
  );
};

export default Login;
